import TopfbandO3 from "../object3d/Topfband";
import Maths3 from "oc-threejs/Maths3";

export default class Topfband {


    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------
    parent: Object;
    object3d: ?THREE.Object3D;
    position = new THREE.Vector3();
    quaternion = Maths3.quaternion.x90;

    constructor(parent) {
        this.parent = parent;
    }

    get schrank() {
        return this.parent.schrank;
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new TopfbandO3(this);
            this.parent.child3dContainer.add(o3);
            return o3;
        });
    }

    iterate(iterator) {
        iterator(this);
    }

}